module.exports = "<h3>Manage your Users</h3>\n<ul\n  class=\"list-group\">\n  <li class=\"list-group-item\">Max</li>\n  <li class=\"list-group-item\">Anna</li>\n  <li class=\"list-group-item\">Chris</li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /Applications/XAMPP/xamppfiles/htdocs/estudos/angular2/animation-course/basic-project/src/app/users/users.component.html
// module id = ../../../../../src/app/users/users.component.html
// module chunks = main